export default '<a href="https://new.favbet.hr/hr/promocije/voucheri/" target="_blank" style="color: #0000ff; text-decoration: underline; font-weight: bold;">Promocije voucheri</a>';
